import React, { useState } from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"
import type { AvailableTextTypography } from "@front-shared/types/elements.types.ts"

import chevronDown from "@front-shared/assets/images/icons/chevron-down-dark.svg"
import chevronUp from "@front-shared/assets/images/icons/chevron-up-dark.svg"

export const CollapseElement: React.FunctionComponent<
    ICollapseElementProps
> = props => {
    const [isOpen, setIsOpen] = useState<boolean>(!props.isDefaultCollapsed)

    const toggle = () => {
        setIsOpen(current => !current)
    }

    return (
        <div
            className={`
                ${props.className}
            `}
        >
            <div className="flex items-start cursor-pointer" onClick={toggle}>
                <PrimaryText
                    typography={props.labelTypography || "h4"}
                    className="mr-[16px]"
                >
                    {props.label}
                </PrimaryText>

                <div
                    className={`
                        mr-[16px] relative
                        ${isOpen ? "top-[8px]" : "top-[10px]"}
                    `}
                >
                    <img
                        src={isOpen ? chevronUp : chevronDown}
                        width={18}
                        alt="toggle"
                    />
                </div>

                <div className="flex-1">{props.rightHeaderContent || null}</div>
            </div>

            {isOpen && (
                <div className={props.rightHeaderContent ? "mt-[12px]" : ""}>
                    {props.content}
                </div>
            )}
        </div>
    )
}

interface ICollapseElementProps {
    className?: string
    isDefaultCollapsed?: boolean
    label: string
    labelTypography?: AvailableTextTypography
    rightHeaderContent?: JSX.Element
    content: JSX.Element
}
